import React from "react";

interface ArthereumIconProps {
  /** Size of the icon in pixels or Tailwind classes (e.g., "24" or "w-6 h-6") */
  size?: string | number;
  /** Additional CSS classes */
  className?: string;
  /** Alt text for accessibility */
  alt?: string;
  /** Click handler */
  onClick?: () => void;
  /** Opacity level (0-1) for background usage */
  opacity?: number;
  /** Custom style object */
  style?: React.CSSProperties;
}

const ArthereumIcon: React.FC<ArthereumIconProps> = ({
  size = 24,
  className = "",
  alt = "arthereum",
  onClick,
  opacity,
  style,
}) => {
  // Handle size prop - can be number, pixel string, or Tailwind classes
  const getSize = () => {
    if (typeof size === "number") {
      return { width: size, height: size };
    }

    if (typeof size === "string") {
      // If it's a number string, treat as pixels
      if (/^\d+$/.test(size)) {
        const pixels = parseInt(size, 10);
        return { width: pixels, height: pixels };
      }

      // If it contains Tailwind classes, don't set inline styles
      if (size.includes("w-") || size.includes("h-")) {
        return {};
      }

      // Otherwise treat as CSS size value
      return { width: size, height: size };
    }

    return { width: 24, height: 24 };
  };

  const sizeStyles = getSize();
  const opacityStyle = opacity !== undefined ? { opacity } : {};

  // Combine all styles
  const combinedStyle = {
    ...sizeStyles,
    ...opacityStyle,
    ...style,
  };

  // Add Tailwind size classes if provided
  const sizeClassName =
    typeof size === "string" && (size.includes("w-") || size.includes("h-"))
      ? size
      : "";
  const combinedClassName = `${sizeClassName} ${className}`.trim();

  return (
    <img
      src="https://images.pexels.com/photos/29554658/pexels-photo-29554658.png?auto=compress&cs=tinysrgb&w=800&lazy=load"
      alt={alt}
      className={combinedClassName}
      style={combinedStyle}
      onClick={onClick}
    />
  );
};

export default ArthereumIcon;
